export function Footer() {
  /* return (
    <footer className="fixed bottom-0 left-0 w-full bg-zinc-100 text-white text-center shadow-md mt-4">
      <div className="mx-auto max-w-7xl px-4 py-6 md:flex md:items-center md:justify-between lg:px-4">
        <div className="flex justify-center gap-x-6 md:order-2">
            <a href="/settings" className="text-gray-600 hover:text-gray-800">
              <span className="sr-only">Settings</span>
              <Cog6ToothIcon />
            </a>
        </div>
        <p className="mt-8 text-center text-sm/6 text-gray-600 md:order-1 md:mt-0">
          &copy; 2025 FeedSumo 2.O - AI Engine, All rights reserved.
        </p>
      </div>
    </footer>
  ) */
 return (
    <></>
 )
}